document.addEventListener('DOMContentLoaded', () => {
    // 1. On cible TOUS les blocs qui ont potentiellement une animation
    const blocks = document.querySelectorAll('.sds-anim-block');

    blocks.forEach(block => {
        // 2. On récupère le code JS brut stocké dans l'attribut
        const codeString = block.getAttribute('data-sds-anim-code');

        // S'il n'y a pas de code, on ne fait rien
        if (!codeString) return;

        try {
            // 3. L'EXÉCUTION DYNAMIQUE
            // On crée une fonction à la volée qui contient ton code.
            // On lui donne accès à 3 variables : 'block' (l'élément HTML), 'gsap' et 'ScrollTrigger'.
            const animFunction = new Function('block', 'gsap', 'ScrollTrigger', codeString);

            // 4. On lance la fonction
            // Cela exécute le code que tu as mis dans l'attribut
            animFunction(block, window.gsap, window.ScrollTrigger);

        } catch (error) {
            console.error('Erreur dans l animation du bloc SDS :', error, block);
        }
    });
});